import { render, staticRenderFns } from "./HairplusConversion.vue?vue&type=template&id=4507dff1"
import script from "./HairplusConversion.vue?vue&type=script&lang=js"
export * from "./HairplusConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports